import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/credits_new.jsx';

const scrollSettings = {top: 0};

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: ''
        };

        this.crefs = {};

        this.closeModal = this.closeModal.bind(this);
        this.showModal = this.showModal.bind(this);

        return this;
    }

    closeModal() {
        this.setState({showModal: ''});
    }

    showModal(name) {
        this.setState({showModal: name});
    }

    componentWillUnmount() {
        window.scrollTo(scrollSettings);
    }

    static displayName = 'Business.Views.CreditsMain';

    static contextTypes = {
        app: PropTypes.object
    };
}
